export class DiaryFormElementTranslation {
  public id: string;
  public culture: string;
  public label: string;
  public placeholder: string;

  constructor(init?: Partial<DiaryFormElementTranslation>) {
    Object.assign(this, init);
  }
}
